module.exports = __webpack_public_path__ + "img/APUA_600X460.c87d43b0.jpg";